import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CarrierListFilters } from '../filters/carrier/carrier-list-filters';
import { FilterSearch } from '../filters/filter-search.model';
import { FreightExchangeListFilters } from '../filters/freight-exchange/freight-exchange-list-filters';
import { IncidentListFilters } from '../filters/incident/incident-list-filters';
import { OrderListFilters } from '../filters/order/order-list-filters';
import { SelfBillListFilters } from '../filters/self-bill/self-bill-list-filters';
import { UserListFilters } from '../filters/user/user-list-filters';
import { ApproveCarriersListFilters } from '../filters/approve-carrier/approve-carrier';
import { TenderListFilters } from '../filters/tender/tender-list-filters';

@Injectable({
  providedIn: 'root',
})
export class FiltersService {
  private static orderListFiltersSubject = new Subject<FilterSearch>();

  static get orderListFilters$() {
    return this.orderListFiltersSubject.asObservable();
  }
  public static OrderListFilters = OrderListFilters;
  public static IncidentListFilters = IncidentListFilters;
  public static SelfBillListFilters = SelfBillListFilters;
  public static CarrierListFilters = CarrierListFilters;
  public static FreightExchangeListFilters = FreightExchangeListFilters;
  public static UserListFilters = UserListFilters;
  public static ApproveCarriersListFilters = ApproveCarriersListFilters;
  public static TenderListFilters = TenderListFilters;

  public static initFilters() {
    FiltersService.ApproveCarriersListFilters.filterSearch = {
      filterSearchValue: '',
    };

    FiltersService.UserListFilters.filterSearch = {
      filterSearchValue: '',
    };

    FiltersService.OrderListFilters.filterSearch = {
      filter: FiltersService.OrderListFilters.defaultFields,
      filterSearchValue: '',
    };

    FiltersService.IncidentListFilters.filterSearch = {
      filter: FiltersService.IncidentListFilters.defaultFields,
      filterSearchValue: '',
    };
    FiltersService.SelfBillListFilters.filterSearch = {
      filter: FiltersService.SelfBillListFilters.defaultFields,
      filterSearchValue: '',
    };
    FiltersService.CarrierListFilters.filterSearch = {
      filterSearchValue: '',
    };
    FiltersService.FreightExchangeListFilters.filterSearch = {
      filter: null,
      filterSearchValue: '',
    };
    FiltersService.TenderListFilters.filterSearch = {
      filter: null,
      filterSearchValue: '',
    };
  }
}
